import axios from "axios";

export const AuthorizationToken = {
  set(token: string) {
    axios.defaults.headers.common.Authorization = `JWT ${token}`;
    axios.defaults.headers.common.version = process.env.VERSION;
  },
  delete() {
    delete axios.defaults.headers.common.Authorization;
  }
};

AuthorizationToken.set(localStorage.jwtToken);
